import { render } from "./EmailSettingsAccountModeTransfer.vue?vue&type=template&id=663e5855&scoped=true"
import script from "./EmailSettingsAccountModeTransfer.vue?vue&type=script&lang=js"
export * from "./EmailSettingsAccountModeTransfer.vue?vue&type=script&lang=js"

import "./EmailSettingsAccountModeTransfer.vue?vue&type=style&index=0&id=663e5855&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663e5855"]])

export default __exports__